import React, { useContext, useState, useEffect, useRef } from "react";
import { TemplateContext } from "../../layout";
import axios from "axios";
import FormAccordionsDivided from "./formAccordionsDivided";

const form = ({ withDividedForm }) => {
  const [reach, setReach] = useState();
  const formLabels = window.post_template?.checkout_v4_form.checkout_v4_formLabels;
  const formSections = window.post_template?.checkout_v4_form.checkout_v4_formHeadings;
  const merchantId = window.general_settings?.merchant_id;
  let formType = window.post_template?.checkout_v4_form?.checkout_v4_radio;
  const reachBase = `https://checkout.rch.io/v2.22/badge?MerchantId=${merchantId}&Locale=${window?.countryCode?.toUpperCase()}`;
  const withReachLocal = window.post_template?.checkout_v4_template_reach?.checkout_v4_template_reach_toggle
    ? "local"
    : null;
  const withReactGlobal = window.reach_global?.reach_global ? "global" : null;
  const withReachVar = withReachLocal || withReactGlobal;
  const variantsEnabled = window.productData?.enable_color_variants || window.productData?.enable_size_variants;

  useEffect(() => {
    if (merchantId) {
      axios
        .get(reachBase)
        .then((response) => {
          const data = response.data;
          setReach(data);
          if (data.result === "ERROR") {
            console.log(data.message);
            setTemplateContext({ ...templateContext, isLoading: false });
          }
        })
        .catch((error) => {
          setTemplateContext({ ...templateContext, isLoading: false });
        });
    }
  }, []);

  if (withDividedForm) {
    formType = "form_paypal_select_divided";
  }
  const [backError, setBackError] = useState();
  const backErrorField = useRef(null);

  const scrollIntoView = (element) => {
    if (element) {
      element.scrollIntoView({ behavior: "smooth", block: "center", inline: "nearest" });
    }
  };

  const [templateContext, setTemplateContext, variantsContext, setVariantsContext] = useContext(TemplateContext);
  const autofillValues = window?.userData;

  let initialValues = {
    email: autofillValues?.email ? autofillValues.email : "",
    first_name: autofillValues?.first_name ? autofillValues.first_name : "",
    last_name: autofillValues?.last_name ? autofillValues.last_name : "",
    address: autofillValues?.address ? autofillValues.address : "",
    country: autofillValues?.country ? autofillValues.country : window.countryCode.toUpperCase(),
    city: autofillValues?.city ? autofillValues.city : "",
    state: autofillValues?.state ? autofillValues.state : "",
    zip: autofillValues?.zip ? autofillValues.zip : "",
    phone: autofillValues?.phone ? autofillValues.phone : "",
    card_number: "",
    card_exp_month: "",
    card_exp_year: "",
    card_cvc: "",
    card_name: "",
    policy: false,
  };

  const cleanCheck =
    (window.isMobile == false && window.msg?.enable_clean_version_in_desktop) ||
    (window.isMobile == true && window.msg?.enable_clean_version_in_mobile);

  const directCheck = window.msg?.clean_checkout_if_direct_customer && window.directCheck;

  const enableCleanVersion = directCheck | cleanCheck;

  const handleFormSubmit = (formValues, templateContext) => {
    if (
      !templateContext.config?.warrantyState &&
      !templateContext.popupClicked &&
      templateContext.showPopup &&
      cleanCheck == false
    ) {
      setTemplateContext((prevContext) => ({
        ...prevContext,
        displayPopup: true,
        formValues: formValues,
        popupClicked: false,
        orderOverviewDrawerOpen: true,
      }));
    } else if (templateContext.useUpsell && !templateContext.upsellPopupClicked) {
      setTemplateContext((prevContext) => ({
        ...prevContext,
        displayUpsellPopup: true,
        formValues: formValues,
      }));
    } else {
      submit(formValues, templateContext);
    }
  };

  useEffect(() => {
    if (backError) {
      scrollIntoView(backErrorField?.current);
    }
  }, [backError]);

  const submit = async (formData, templateContext) => {
    const fields = window.productData;
    const navigator = window.navigator;

    const browserData = {
      acceptHeader: "application/json",
      colorDepth: screen.colorDepth,
      javaEnabled: navigator.javaEnabled(),
      javaScriptEnabled: true,
      language: navigator.language,
      screenHeight: screen.height,
      screenWidth: screen.width,
      timeZoneOffset: new Date().getTimezoneOffset().toString(),
      userAgent: navigator.userAgent,
    };

    const requestData = {
      data: formData,
      affiliate: window.affiliate,
      products: {
        ...templateContext?.config,
        warrantyTitle: window.post_template?.checkout_v4_summary?.tr_checkout_v4_summary_extended_warranty,
        warranty_price:
          window?.productData?.add_warranty_for_product === false
            ? 0
            : templateContext?.config?.product?.warranty_price,
        warrantyType: window.productData?.select_warranty_type_cc ?? null,
        warrantyPriceCalculation:
          window?.productData?.add_warranty_for_product == false ? false : window.productData?.multiply_price_by_amount,
        isWarrantySelected: templateContext?.config?.warrantyState ? templateContext?.config?.warrantyState : false,
        currencyCode: fields?.currency_code,
        postId: window.getPostId,
        variants:
          variantsEnabled && variantsContext?.variants?.length > 0
            ? variantsContext?.variants?.slice(0, templateContext?.config?.product?.amount)
            : null,
      },
      upsell_path: fields?.next_page_on_success,
      return_to: window.location.href,
      browserData: browserData,
      paypalMerchant: fields?.paypal_merchant,
      discountsEnabled: window.productData?.enable_discount_codes,
      appliedDiscountCode: window.productData?.discount_codes?.discount_code,
      isDiscountApplied: templateContext?.discountCode === window.productData?.discount_codes?.discount_code,
    };

    if (templateContext?.paymentMethod == "paypal" && templateContext?.paypalHandler !== "wr") {
      const paypalData = {
        products: {
          currencyCode: fields?.currency_code,
          paypalMerchant: fields?.paypal_merchant,
          campaignId: templateContext?.config.campaignId,
          ...templateContext?.config,
          warranty_price:
            window?.productData?.add_warranty_for_product == false
              ? 0
              : templateContext?.config?.product?.warranty_price,
          isWarrantySelected: templateContext?.config?.warrantyState,
          warrantyType: window.productData?.select_warranty_type_cc,
          warrantyPriceCalculation:
            window?.productData?.add_warranty_for_product == false
              ? false
              : window.productData?.multiply_price_by_amount,
          postId: window.getPostId,
          variants:
            variantsEnabled && variantsContext?.variants?.length > 0
              ? variantsContext?.variants?.slice(0, templateContext?.config?.product?.amount)
              : null,
        },
        nextStep: fields?.next_page_on_success,
        upsell: fields?.paypal_upsell ? fields?.paypal_upsell_settings : null,
        thankYou: fields?.paypal_thank_you_page,
        return_to: window.location.href,
        warrantyTitle: window.post_template?.checkout_v4_summary?.tr_checkout_v4_summary_extended_warranty,
        affiliate: window.affiliate,
        discountsEnabled: window.productData?.enable_discount_codes,
        appliedDiscountCode: window.productData?.discount_codes?.discount_code,
        isDiscountApplied: templateContext?.discountCode === window.productData?.discount_codes?.discount_code,
      };

      setTemplateContext({ ...templateContext, isLoading: true });
      setBackError(null);
      axios
        .post("/wp-json/checkout/v1/order/paypal", paypalData)
        .then((response) => {
          const data = response.data;
          if (data.result === "ERROR") {
            setTemplateContext({ ...templateContext, isLoading: false });
            setBackError(data.message);
            console.log(data.message);
          } else {
            window.location.href = data;
          }
        })
        .catch((error) => {
          console.log(error);
          setBackError(error);
          setTemplateContext({ ...templateContext, isLoading: false });
        });
    } else {
      let url = "/wp-json/checkout/v1/order";

      if (templateContext?.paypalHandler == "wr") {
        url = "/wp-json/checkout/v1/order/pp-wr";
      }

      setTemplateContext({ ...templateContext, isLoading: true });
      setBackError(null);
      axios
        .post(url, requestData)
        .then((response) => {
          const data = response.data;
          if (data.result === "ERROR") {
            setBackError(data.message);
            setTemplateContext({ ...templateContext, isLoading: false });
            console.log(data.message);
          } else if (data.result === "SUCCESS") {
            // Successful payment
            window.location.href = templateContext?.config.nextStep + "?orderId=" + data.message.orderId;
          } else if (data.result === "MERC_REDIRECT") {
            // 3DS Bank Auth
            const message = data.message;
            if (message && message.url) {
              window.location.href = message.url;
            } else if (message && message.script) {
              eval(message.script);
            }
          }
        })
        .catch((error) => {
          console.error(error);
          setBackError(error);
          setTemplateContext({ ...templateContext, isLoading: false });
        });
    }
  };

  useEffect(() => {
    if (templateContext?.popupClicked) {
      handleFormSubmit(templateContext.formValues, templateContext);
    }
  }, [templateContext?.popupClicked]);

  useEffect(() => {
    if (templateContext?.upsellPopupClicked) {
      handleFormSubmit(templateContext.formValues, templateContext);
    }
  }, [templateContext?.upsellPopupClicked]);

  let formComponent;

  formComponent = (
    <>
      <FormAccordionsDivided
        handleFormSubmit={handleFormSubmit}
        labels={formLabels}
        initialValues={initialValues}
        headings={formSections}
        formSubmited={templateContext?.isLoading}
        submitFunc={submit}
        withReach={withReachVar}
        compliance={!!templateContext?.compliance}
        cleanVersion={!!enableCleanVersion}
        reachData={reach}
      />
      {backError && (
        <div ref={backErrorField} className="error-back">
          {backError}
        </div>
      )}
    </>
  );

  return formComponent;
};

export default form;
